<template>
    <ModalAlert @close="$emit('close')">
        <div class="content">
            <div class="warningTitle">
                <img  src="../assets/icons/success.svg" />
                <p>{{ $t('thankYouOrder') }}</p>
            </div>
            <div class="caption">
                {{ $t('seeYou') }}
            </div>
        </div>
    </ModalAlert>
</template>

<script>
    import { Component, Vue } from 'vue-property-decorator'
    import ModalAlert from '@/components/Alert.vue'
    @Component({
        components: {
            ModalAlert
        }
    })
    export default class ThankYouOrderModal extends Vue {
    }
</script>
<style  lang="scss" scoped>
    .content {
        font-size: 16px;
        font-weight: bold;
        color: #646979;
        font-stretch: condensed;
    }

    .caption {
        /* display: block; */
        padding: 10px;
        text-align: center;

    }

    .warningTitle {
        padding: 5%;
        background-color: #fdb947;
        color: white;
        font-size: 18px;
        text-align: center;
        font-weight: bold;
        img{
        max-width: 100%;
        width: 30%;
        margin-left: auto;
        margin-right: auto;
        display: block;
        }
    }

    .icon {
        width: 40%;
        margin-left: auto;
        margin-right: auto;
        display: block;
    }
</style>
